import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-flex tw-justify-center tw-items-center tw-p-2 recetas" }
const _hoisted_2 = { class: "tw-w-full tw-bg-gray-50 tw-rounded tw-shadow tw-py-4 tw-px-8 tw-flex tw-justify-center tw-items-center" }
const _hoisted_3 = { class: "tw-px-2" }
const _hoisted_4 = { class: "tw-cursor-pointer tw-underline" }
const _hoisted_5 = {
  key: 1,
  class: "tw-w-full tw-bg-gray-50 tw-rounded tw-shadow tw-py-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "No se encontraron datos.", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_recetas_card = _resolveComponent("recetas-card")!
  const _component_Card = _resolveComponent("Card")!
  const _component_SolicitudReceta = _resolveComponent("SolicitudReceta")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SolicitudesPendientesCard = _resolveComponent("SolicitudesPendientesCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createVNode(_component_Card, {
      style: {"background":"none","box-shadow":"none"},
      class: "animate tw-m-auto tw-w-full"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", {
            class: _normalizeClass({"tw-ml-auto":_ctx.$store.state.configuracionPortal.permite_solicitudes})
          }, "Recetas", 2),
          (_ctx.$store.state.configuracionPortal.permite_solicitudes)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Solicitar",
                class: "tw-ml-auto",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSolicitudReceta()))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      subtitle: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.CantidadPedidos)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                onClick: _ctx.handleClickMensajeSolicitudes,
                severity: "success",
                closable: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_4, " Usted posee " + _toDisplayString(_ctx.CantidadPedidos > 1 ? _ctx.CantidadPedidos : 'una') + " solicitud" + _toDisplayString(_ctx.CantidadPedidos > 1 ? 'es' : '') + " en curso. ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.recetasList.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "contenedorResultados",
              style: _normalizeStyle(`max-height:calc(100vh - ${_ctx.CantidadPedidos ? "34vh" : "28vh"})`),
              class: "tw-w-full tw-grid xl:tw-grid-cols-2 tw-gap-2 tw-bg-gray-100 tw-overflow-auto tw-p-2 tw-rounded"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recetasList, (item) => {
                return (_openBlock(), _createBlock(_component_recetas_card, {
                  key: item,
                  dato: item,
                  onDuplicar: ($event: any) => (_ctx.handleSolicitudReceta(item)),
                  onDescargar: ($event: any) => (_ctx.descargarRecetas(item))
                }, null, 8, ["dato", "onDuplicar", "onDescargar"]))
              }), 128))
            ], 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      appendTo: "self",
      header: "Solicitud Receta",
      style: {'max-width': '90%',},
      visible: _ctx.solicitudRecetaForm,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.solicitudRecetaForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SolicitudReceta, { onClose: _ctx.handleSolicitudRecetaClose }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      appendTo: "self",
      header: "Solicitudes Activas",
      style: {'max-width': '90%',},
      visible: _ctx.SolicitudesActivasForm,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.SolicitudesActivasForm) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SolicitudesActivas, (solicitud) => {
          return (_openBlock(), _createBlock(_component_SolicitudesPendientesCard, {
            key: solicitud,
            solicitudPendiente: solicitud,
            onCancelarSolicitud: ($event: any) => (_ctx.handleCancelarSolicitud(solicitud))
          }, null, 8, ["solicitudPendiente", "onCancelarSolicitud"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}